var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _line, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _g, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovativeAntibodies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2275,
    height: 1388,
    viewBox: "0 0 2275 1388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 968,
    width: 2275,
    height: 420,
    rx: 100,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.637 1254H160.341V1134.79H123.637V1254Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.365 1254H466.069V1134.79H429.365V1254Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.82 1254H290.523V1134.79H253.82V1254Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.547 1254H596.251V1134.79H559.547V1254Z",
    fill: "#D2D2D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.608 1155.94H596.038V143.324H253.608V1155.94Z",
    fill: "#D2D2D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.327 1155.94H466.759V143.324H124.327V1155.94Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.835 143.306H413.742V10H378.835V143.306Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.927 143.306H378.834V10H343.927V143.306Z",
    fill: "#ECECEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.742 143.306H448.649V10H413.742V143.306Z",
    fill: "#ECECEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.422 143.306H448.649V10H542.422C546.339 10 549.515 13.1737 549.515 17.0914V136.215C549.515 140.131 546.339 143.306 542.422 143.306Z",
    fill: "#D2D2D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.412 62.9832H518.754V49.7837H479.412V62.9832Z",
    fill: "#ECECEC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.981 1122.58H436.237V831.122H154.981V1122.58Z",
    fill: "#ECECEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.982 1122.58H252.015V831.122H154.982V1122.58Z",
    fill: "#D2D2D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.981 794.953H436.237V503.498H154.981V794.953Z",
    fill: "#ECECEC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.982 794.953H252.015V503.498H154.982V794.953Z",
    fill: "#D2D2D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.981 467.328H436.237V175.873H154.981V467.328Z",
    fill: "#ECECEC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.982 467.328H252.015V175.873H154.982V467.328Z",
    fill: "#D2D2D2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.324 1122.58H250.161V1016.27H222.324V1122.58Z",
    fill: "#E0E0E0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.487 1122.58H222.324V1016.27H194.487V1122.58Z",
    fill: "#ECECEC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.161 1122.58H277.998V1016.27H250.161V1122.58Z",
    fill: "#ECECEC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.34 1122.58H277.997V1016.27H351.34C355.259 1016.27 358.435 1019.44 358.435 1023.36V1115.48C358.435 1119.4 355.259 1122.58 351.34 1122.58Z",
    fill: "#D2D2D2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.918 1042.28H346.515V1031.76H289.918V1042.28Z",
    fill: "#ECECEC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.529 1058.52H333.903V1048H302.529V1058.52Z",
    fill: "#ECECEC"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 181.794,
    y1: 386.205,
    x2: 413.832,
    y2: 386.205,
    stroke: "#A6A6A6",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M201.708 298.047H188.893V314.45H201.708V298.047Z",
    fill: "#ADADAD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M204.527 314.45H185.818C180.435 314.45 176.078 318.807 176.078 324.189V362.377H214.266V324.189C214.266 318.807 209.909 314.45 204.527 314.45Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 298.047H269.369V314.45H282.184V298.047Z",
    fill: "#ADADAD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M285.003 314.45H266.294C260.912 314.45 256.555 318.807 256.555 324.189V362.377H294.742V324.189C294.742 318.807 290.385 314.45 285.003 314.45Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M351.895 298.047H339.081V314.45H351.895V298.047Z",
    fill: "#ADADAD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M354.715 314.45H336.005C330.623 314.45 326.266 318.807 326.266 324.189V362.377H364.454V324.189C364.454 318.807 360.097 314.45 354.715 314.45Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M402.385 298.047H389.571V314.45H402.385V298.047Z",
    fill: "#ADADAD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M405.205 314.45H386.495C381.113 314.45 376.756 318.807 376.756 324.189V362.377H414.944V324.189C414.944 318.807 410.587 314.45 405.205 314.45Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M202.073 402.87H189.259V419.273H202.073V402.87Z",
    fill: "#ADADAD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M204.893 419.272H186.183C180.801 419.272 176.444 423.629 176.444 429.012V467.199H214.632V429.012C214.632 423.629 210.275 419.272 204.893 419.272Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M282.549 402.87H269.735V419.273H282.549V402.87Z",
    fill: "#ADADAD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M285.369 419.272H266.659C261.277 419.272 256.92 423.629 256.92 429.012V467.199H295.108V429.012C295.108 423.629 290.751 419.272 285.369 419.272Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M352.261 402.87H339.446V419.273H352.261V402.87Z",
    fill: "#ADADAD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M355.08 419.272H336.371C330.989 419.272 326.632 423.629 326.632 429.012V467.199H364.819V429.012C364.819 423.629 360.462 419.272 355.08 419.272Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M402.751 402.87H389.936V419.273H402.751V402.87Z",
    fill: "#ADADAD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M405.57 419.272H386.861C381.479 419.272 377.122 423.629 377.122 429.012V467.199H415.31V429.012C415.31 423.629 410.953 419.272 405.57 419.272Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M199.136 754.646C198.242 757.329 197.944 760.011 197.944 762.992C197.944 779.088 211.059 792.204 227.155 792.204C243.251 792.204 256.367 779.088 256.367 762.992C256.367 760.011 256.069 757.329 255.175 754.646H199.136Z",
    fill: "#DFE33D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M238.483 732.29V693.54H215.829V732.29C203.309 737.059 194.367 748.982 194.367 762.992C194.367 781.175 208.973 795.78 227.156 795.78C245.338 795.78 259.944 781.175 259.944 762.992C259.944 748.684 251.002 736.761 238.483 732.29Z",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M331.781 754.646C330.887 757.329 330.589 760.011 330.589 762.992C330.589 779.088 343.704 792.204 359.8 792.204C375.897 792.204 389.012 779.088 389.012 762.992C389.012 760.011 388.714 757.329 387.82 754.646H331.781Z",
    fill: "#DFE33D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M371.425 732.29V693.54H348.771V732.29C336.252 737.059 327.31 748.982 327.31 762.992C327.31 781.175 341.916 795.78 360.098 795.78C378.281 795.78 392.887 781.175 392.887 762.992C392.887 748.684 383.945 736.761 371.425 732.29Z",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M269.781 765.376C269.185 767.463 268.887 769.251 268.887 771.636C268.887 783.559 278.724 793.395 290.647 793.395C302.57 793.395 312.406 783.559 312.406 771.636C312.406 769.549 312.108 767.463 311.512 765.376H269.781Z",
    fill: "#DFE33D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M299.291 748.684V719.771H282.3V748.684C273.06 752.261 266.502 760.905 266.502 771.338C266.502 784.751 277.531 795.78 290.945 795.78C304.358 795.78 315.387 784.751 315.387 771.338C315.089 760.905 308.531 751.963 299.291 748.684Z",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M245.266 77.0088H203.632V86.2609H245.266V77.0088Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M147.502 143.315V122.961C147.502 117.101 149.97 111.241 154.596 107.232L179.885 85.3354H272.098L296.153 107.54C300.471 111.55 302.938 117.101 302.938 122.652V146.708L147.502 143.315Z",
    fill: "#C4C4C4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M269.631 111.241C269.631 119.877 249.893 126.662 225.22 126.662C200.548 126.662 180.81 119.877 180.81 111.241C180.81 102.606 200.548 95.8213 225.22 95.8213C249.893 95.8213 269.631 102.915 269.631 111.241Z",
    fill: "#F0F0F0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M702.672 154.721C702.672 208.765 746.497 252.577 800.559 252.577C854.619 252.577 898.442 208.765 898.442 154.721C898.442 100.676 854.619 56.8647 800.559 56.8647C746.497 56.8647 702.672 100.676 702.672 154.721Z",
    fill: "#ECECEC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.865 154.721C721.865 208.765 765.692 252.577 819.752 252.577C873.812 252.577 917.635 208.765 917.635 154.721C917.635 100.676 873.812 56.8647 819.752 56.8647C765.692 56.8647 721.865 100.676 721.865 154.721Z",
    fill: "#E0E0E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.574 154.714C745.574 192.911 774.453 224.355 811.559 228.431C814.252 228.728 816.976 228.876 819.743 228.876C860.718 228.876 893.928 195.677 893.928 154.714C893.928 113.765 860.718 80.5654 819.743 80.5654C816.976 80.5654 814.252 80.7148 811.559 81.0121C774.453 85.0874 745.574 116.531 745.574 154.714Z",
    fill: "#ECECEC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.574 154.714C745.574 192.912 774.453 224.355 811.559 228.431C848.683 224.355 877.561 192.912 877.561 154.714C877.561 116.531 848.683 85.0875 811.559 81.0122C774.453 85.0875 745.574 116.531 745.574 154.714Z",
    fill: "#F4F4F4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M816.533 113.483L792.499 165.887",
    stroke: "#ECECEC",
    strokeWidth: 8
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M790.209 143.918L842.857 201.127",
    stroke: "#ECECEC",
    strokeWidth: 8
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M801.511 1253.82H826.385V755.812H801.511V1253.82Z",
    fill: "#EAEAEB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M776.636 1253.82H801.51V755.812H776.636V1253.82Z",
    fill: "#D8D8D8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.877 1253.82H1021.75V755.812H996.877V1253.82Z",
    fill: "#EAEAEB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972.002 1253.82H996.876V755.812H972.002V1253.82Z",
    fill: "#D8D8D8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M801.511 965.048H996.877V755.812H801.511V965.048Z",
    fill: "#EAEAEB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.012 755.813H1362.91V722.688H710.012V755.813Z",
    fill: "#D8D8D8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1314.18 755.813H1577.08V722.688H1314.18V755.813Z",
    fill: "#EAEAEB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1485.06 1253.82H1511.65V755.812H1485.06V1253.82Z",
    fill: "#EAEAEB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1458.46 1253.82H1485.06V755.812H1458.46V1253.82Z",
    fill: "#D8D8D8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.35 1253.82H1301.94V755.812H1275.35V1253.82Z",
    fill: "#EAEAEB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.35 1008.67H1485.06V755.956H1275.35V1008.67Z",
    fill: "#EAEAEB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1074.96 1008.55H1248.75V755.837H1074.96V1008.55Z",
    fill: "#D8D8D8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1248.75 1253.82H1275.35V755.812H1248.75V1253.82Z",
    fill: "#D8D8D8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1248.75 800.093H1511.65V755.812H1248.75V800.093Z",
    fill: "#D8D8D8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M776.636 800.093H1021.75V755.812H776.636V800.093Z",
    fill: "#D8D8D8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.03 867.488H1220.67V779.904H1103.03V867.488Z",
    fill: "#EAEAEB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.03 978.503H1220.67V890.919H1103.03V978.503Z",
    fill: "#EAEAEB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1180.28 823.696C1180.28 834.069 1172.03 842.48 1161.85 842.48C1151.68 842.48 1143.43 834.069 1143.43 823.696C1143.43 813.322 1151.68 804.913 1161.85 804.913C1172.03 804.913 1180.28 813.322 1180.28 823.696Z",
    fill: "#D8D8D8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1180.28 934.71C1180.28 945.084 1172.03 953.495 1161.85 953.495C1151.68 953.495 1143.43 945.084 1143.43 934.71C1143.43 924.337 1151.68 915.927 1161.85 915.927C1172.03 915.927 1180.28 924.337 1180.28 934.71Z",
    fill: "#D8D8D8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1251.84 143.7H1356.14L1370.23 3H1265.93L1251.84 143.7Z",
    fill: "#EAEAEB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1251.84 143.7H1356.14L1370.23 3H1265.93L1251.84 143.7Z",
    stroke: "#EAEAEB",
    strokeWidth: 5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1246.21 143.7H1352.45L1366.54 3H1260.3L1246.21 143.7Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1246.21 143.7H1352.45L1366.54 3H1260.3L1246.21 143.7Z",
    stroke: "#EAEAEB",
    strokeWidth: 5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.56 125.122H1335.82L1346.19 21.5776H1276.93L1266.56 125.122Z",
    fill: "#EAEAEB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1094.05 105.893C1094.05 113.355 1100.1 119.405 1107.56 119.405H1229.13V92.3799H1107.56C1100.1 92.3799 1094.05 98.43 1094.05 105.893Z",
    fill: "#C4C4C4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1175.82 105.893C1175.82 110.212 1179.32 113.714 1183.64 113.714H1228.81C1228.99 113.714 1229.13 113.57 1229.13 113.39V98.3941C1229.13 98.2147 1228.99 98.0698 1228.81 98.0698H1183.64C1179.32 98.0698 1175.82 101.572 1175.82 105.893Z",
    fill: "#EAEAEB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1077.08 119.405V146.43H1209.78C1217.24 146.43 1223.29 140.38 1223.29 132.918C1223.29 125.455 1217.24 119.405 1209.78 119.405H1077.08Z",
    fill: "#C4C4C4"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1077.08 125.17V140.665H1131.64C1135.92 140.665 1139.39 137.196 1139.39 132.918C1139.39 128.638 1135.92 125.17 1131.64 125.17H1077.08Z",
    fill: "#EAEAEB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1034 164.383H1491.43V145.167H1034V164.383Z",
    fill: "#EAEAEB"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1491.43 164.383H1566.69V145.167H1491.43V164.383Z",
    fill: "#C4C4C4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1145.49 164.382L1181.21 220.425V164.382H1145.49Z",
    fill: "#D8D8D8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1125.72 164.382L1161.44 220.425H1181.21L1145.49 164.382H1125.72Z",
    fill: "#C4C4C4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1407.49 164.382L1443.21 220.425V164.382H1407.49Z",
    fill: "#D8D8D8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1387.72 164.382L1423.44 220.425H1443.21L1407.49 164.382H1387.72Z",
    fill: "#C4C4C4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1429.57 136.165L1414.24 76.6838V60.4194H1392.55V76.6838L1377.22 136.165C1376.13 140.192 1379.23 144.065 1383.26 144.065H1423.38C1427.72 144.065 1430.66 140.192 1429.57 136.165Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.18 106.114H1389.92L1381.87 137.404C1381.71 138.023 1382.02 138.643 1382.18 138.798C1382.33 139.108 1382.79 139.418 1383.41 139.418H1423.53C1424.31 139.418 1424.62 138.953 1424.77 138.798C1424.93 138.643 1425.24 138.023 1425.08 137.404L1417.18 106.114Z",
    fill: "#DFE33D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1473.72 87.8368V53.4492H1453.58V87.8368C1442.59 91.8641 1434.53 102.552 1434.53 115.099C1434.53 131.208 1447.54 144.22 1463.65 144.22C1479.76 144.22 1492.77 131.208 1492.77 115.099C1492.77 102.552 1484.87 91.8641 1473.72 87.8368Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.87 107.664C1438.25 109.988 1437.78 112.466 1437.78 115.099C1437.78 129.505 1449.4 141.122 1463.81 141.122C1478.21 141.122 1489.83 129.505 1489.83 115.099C1489.83 112.466 1489.52 110.142 1488.75 107.664H1438.87Z",
    fill: "#DFE33D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1533.51 106.889V44H1520.19V106.889C1512.91 109.522 1507.64 116.648 1507.64 124.857C1507.64 135.39 1516.16 144.065 1526.85 144.065C1537.38 144.065 1546.06 135.545 1546.06 124.857C1546.06 116.648 1540.79 109.677 1533.51 106.889Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.43 120.055C1509.97 121.604 1509.66 123.153 1509.66 124.857C1509.66 134.306 1517.25 142.051 1526.85 142.051C1536.3 142.051 1544.05 134.461 1544.05 124.857C1544.05 123.153 1543.74 121.604 1543.27 120.055H1510.43Z",
    fill: "#DFE33D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M955.191 453.544H866.982V722.981H955.191V453.544Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.17 322.034H705V662.84H1117.17V322.034Z",
    fill: "#545454"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.11 346.091H733.869V639.585H1089.11V346.091Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M810.047 415.857L919.105 495.245L845.331 536.142",
    stroke: "#828282",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M972.833 420.669L919.106 495.246L944.767 592.275",
    stroke: "#828282",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M919.106 495.245L1034.58 561",
    stroke: "#828282",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M819.671 409.442C819.671 423.876 807.642 435.905 793.208 435.905C778.774 435.905 766.746 423.876 766.746 409.442C766.746 395.008 778.774 382.979 793.208 382.979C807.642 382.979 819.671 395.008 819.671 409.442Z",
    fill: "#DFE33D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M872.597 536.143C872.597 550.577 860.568 562.606 846.134 562.606C831.7 562.606 819.671 550.577 819.671 536.143C819.671 521.709 831.7 509.68 846.134 509.68C860.568 508.879 872.597 520.907 872.597 536.143Z",
    fill: "#DFE33D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.1 420.668C1000.1 435.102 988.069 447.13 973.635 447.13C959.201 447.13 947.172 435.102 947.172 420.668C947.172 406.233 959.201 394.205 973.635 394.205C988.069 394.205 1000.1 406.233 1000.1 420.668Z",
    fill: "#DFE33D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.04 560.999C1061.04 575.433 1049.01 587.462 1034.58 587.462C1020.15 587.462 1008.12 575.433 1008.12 560.999C1008.12 546.565 1020.15 534.537 1034.58 534.537C1049.01 534.537 1061.04 546.565 1061.04 560.999Z",
    fill: "#DFE33D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M944.766 618.735C959.381 618.735 971.228 606.887 971.228 592.273C971.228 577.658 959.381 565.81 944.766 565.81C930.151 565.81 918.303 577.658 918.303 592.273C918.303 606.887 930.151 618.735 944.766 618.735Z",
    fill: "#DFE33D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.25 718.125H1084.09C1079.82 718.125 1076.32 714.631 1076.32 710.361V631.562H1093.21V710.361C1093.01 714.631 1089.52 718.125 1085.25 718.125Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.13 663.392V709.585C1076.13 714.243 1079.82 717.93 1084.47 717.93C1089.13 717.93 1092.82 714.243 1092.82 709.585V663.198H1076.13V663.392Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.93 628.845H1073.22V644.76H1095.93V628.845Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.27 718.125C1112.62 718.125 1108.93 714.437 1108.93 709.779V631.562H1125.81V709.585C1125.81 714.243 1121.93 718.125 1117.27 718.125Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.93 663.392V709.585C1108.93 714.243 1112.62 717.93 1117.27 717.93C1121.93 717.93 1125.62 714.243 1125.62 709.585V663.198H1108.93V663.392Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.73 628.845H1106.02V644.76H1128.73V628.845Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.08 718.125C1145.42 718.125 1141.73 714.437 1141.73 709.779V631.562H1158.62V709.585C1158.62 714.243 1154.73 718.125 1150.08 718.125Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.73 663.392V709.585C1141.73 714.243 1145.42 717.93 1150.08 717.93C1154.73 717.93 1158.42 714.243 1158.42 709.585V663.198H1141.73V663.392Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.33 628.845H1138.62V644.76H1161.33V628.845Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.88 718.125C1178.22 718.125 1174.53 714.437 1174.53 709.779V631.562H1191.42V709.585C1191.42 714.243 1187.54 718.125 1182.88 718.125Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.53 663.392V709.585C1174.53 714.243 1178.22 717.93 1182.88 717.93C1187.54 717.93 1191.22 714.243 1191.22 709.585V663.198H1174.53V663.392Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.13 628.845H1171.43V644.76H1194.13V628.845Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.5 653.3H1061.77V658.347H1208.5V710.362H1054.58V722.395H1218.59V719.484V710.362V658.347V653.3H1208.5Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M2213 674.125C2247.24 674.125 2275.39 701.982 2271.31 735.98C2263.34 802.373 2242.62 866.377 2210.28 923.593C2167.98 998.419 2107.51 1058.63 2035.75 1097.37C1963.99 1136.12 1883.82 1151.83 1804.37 1142.74C1743.04 1135.72 1684.04 1114.13 1631.32 1079.74C1604.57 1062.29 1600.37 1026 1618.77 999.897L1829.83 700.41C1841.45 683.929 1860.35 674.125 1880.51 674.125H2213Z",
    fill: "#005D5F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1686.97 267.617L1691.75 318.171C1691.75 318.171 1719.55 316.205 1727.7 299.915C1735.84 283.626 1732.19 262.281 1732.19 262.281L1728.54 242.902C1728.54 242.902 1714.21 235.319 1699.33 244.307C1684.73 253.294 1686.97 267.617 1686.97 267.617Z",
    fill: "#B5B5B5",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1885.25 429.669L1783.02 404.673L1732.47 262C1732.47 262 1720.39 284.468 1711.97 294.579C1703.54 304.69 1686.97 314.239 1686.97 314.239C1686.97 314.239 1704.1 407.762 1710.28 437.813C1716.18 467.865 1717.02 472.92 1724.89 479.941C1732.75 486.682 1825.43 545.099 1825.43 545.099C1825.43 545.099 1794.54 602.674 1791.17 643.116C1787.8 683.559 1785.27 730.742 1785.27 730.742C1785.27 730.742 1860.82 610.537 1888.34 575.15C1915.87 540.044 1927.1 486.682 1920.92 459.158C1914.46 432.196 1885.25 429.669 1885.25 429.669Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1849.02 457.194L1825.15 545.662L1807.74 440.904",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1780.22 407.201C1780.22 407.201 1753.53 416.75 1749.32 447.644",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1761.4 407.201C1761.4 407.201 1728.82 413.942 1727.13 448.486",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1882.45 463.091L1839.48 552.402L1849.02 568.691L1827.4 586.104L1821.5 619.525",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M2036.07 352.715C2036.07 352.715 2086.62 369.004 2103.2 400.741C2119.48 432.477 2079.88 490.051 2073.99 511.677C2068.09 533.022 2076.51 540.886 2084.38 534.988C2092.24 529.09 2100.67 540.886 2092.24 554.648C2083.54 568.409 2036.35 558.018 2020.91 550.435C2005.46 542.571 2008.83 491.175 2017.54 457.754C2026.24 424.332 2036.35 386.417 2031.3 370.128C2025.68 353.557 2036.07 352.715 2036.07 352.715Z",
    fill: "#010101",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1875.99 282.783C1875.99 282.783 1850.99 312.834 1849.3 324.911C1847.62 336.987 1848.46 343.728 1848.46 343.728C1848.46 343.728 1836.39 357.489 1833.86 359.175C1831.33 360.86 1822.62 365.915 1827.96 372.936C1833.02 379.677 1841.72 379.677 1841.72 379.677C1841.72 379.677 1840.88 406.358 1843.41 418.434C1845.93 430.511 1851.27 434.724 1860.54 435.566C1870.09 436.409 1881.88 436.409 1881.88 436.409L1891.43 484.435L1879.36 547.065L1968.67 449.89C1968.67 449.89 1959.96 414.783 1959.96 407.762C1959.96 401.021 1972.88 388.102 1961.65 351.872C1950.69 316.204 1875.99 282.783 1875.99 282.783Z",
    fill: "#FFD2D2",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1962.77 374.622C1962.77 374.622 1947.32 379.677 1943.11 368.724C1938.9 357.49 1945.64 343.728 1924.29 331.652C1902.95 319.575 1865.03 311.15 1857.17 291.209C1849.3 271.549 1858.01 250.766 1870.09 248.239C1882.16 245.711 1896.77 252.451 1919.8 253.294C1943.11 254.137 2011.08 253.856 2032.42 286.435C2053.77 319.013 2033.26 377.711 2027.08 390.631C2021.19 403.55 2021.19 436.971 1996.19 438.656C1971.19 440.341 1954.06 421.524 1952.38 407.763C1950.69 394.563 1962.77 374.622 1962.77 374.622Z",
    fill: "#020202",
    stroke: "black",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1968.67 364.51L1845.09 322.382C1845.09 322.382 1822.62 336.144 1838.35 354.119L1901.82 374.621L1968.11 372.936L1968.67 364.51Z",
    fill: "white"
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1968.67 364.51L1845.09 322.382C1845.09 322.382 1822.62 336.144 1838.35 354.119L1901.82 374.621L1968.11 372.936L1968.67 364.51Z",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1968.67 364.51L1845.09 322.382",
    stroke: "#005D5F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1914.46 349.063L1901.54 374.621",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1946.2 380.801C1948.73 380.801 1971.19 350.749 1982.15 359.456C1993.38 368.162 1982.99 399.056 1969.23 404.954C1955.47 410.852 1944.23 396.247 1944.23 396.247",
    fill: "#B5B5B5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1946.2 380.801C1948.73 380.801 1971.19 350.749 1982.15 359.456C1993.38 368.162 1982.99 399.056 1969.23 404.954C1955.47 410.852 1944.23 396.247 1944.23 396.247",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1863.07 346.536C1863.07 350.749 1864.47 354.4 1866.44 354.4C1868.4 354.4 1869.81 351.03 1869.81 346.536C1869.81 342.323 1868.4 338.672 1866.44 338.672C1864.47 338.672 1863.07 342.043 1863.07 346.536Z",
    fill: "#005D5F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1971.19 440.061C1971.19 440.061 1926.54 477.134 1901.54 517.295C1876.55 557.738 1813.07 629.917 1802.68 653.789C1792.29 677.943 1783.87 702.658 1783.87 723.441C1783.87 743.943 1782.18 900.378 1782.18 903.748C1782.18 907.118 1782.18 1011.88 1782.18 1011.88H2045.9C2045.9 1011.88 2029.61 786.071 2029.61 737.764C2029.61 689.739 2050.11 645.926 2034.67 577.117C2019.22 508.87 1993.66 469.27 1971.19 440.061Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1988.33 465.056L1893.12 596.495L1868.96 588.631L1870.65 617.84L1810.55 649.576",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1808.3 899.535H1947.04V921.722H1819.53",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1660.57 365.914H1661.41C1664.79 365.914 1667.31 363.106 1667.31 360.016V322.382H1654.39V360.016C1654.39 363.387 1657.2 365.914 1660.57 365.914Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1651.3 314.52H1670.4V327.439H1651.3V314.52Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1595.13 245.149C1595.13 245.149 1588.39 255.821 1589.24 262C1590.08 268.179 1599.35 295.702 1602.16 296.264C1604.96 296.826 1605.53 293.455 1604.68 283.626C1603.84 274.077 1602.16 267.617 1602.16 264.809C1602.44 262 1600.47 239.251 1595.13 245.149Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1724.61 232.23C1724.61 232.23 1735.56 251.328 1727.42 262.562C1719.27 273.515 1701.58 274.639 1701.58 274.639C1701.58 274.639 1698.77 296.264 1694.28 299.635C1690.06 303.005 1679.39 317.89 1677.99 323.226C1676.58 328.562 1666.47 321.822 1666.47 317.328C1666.47 313.116 1673.77 295.703 1675.74 290.928C1677.7 286.154 1673.21 273.234 1671.81 268.741C1670.4 264.528 1669 262.562 1669 262.562C1669 262.562 1654.96 276.043 1653.55 283.626C1652.15 291.209 1656.08 319.575 1652.15 322.945C1648.22 326.316 1638.1 325.473 1636.14 319.575C1634.17 313.677 1630.8 280.256 1630.8 274.358C1630.8 268.46 1640.07 248.8 1640.07 248.8C1640.07 248.8 1625.19 263.686 1624.62 269.022C1624.06 274.358 1628.56 308.06 1626.03 308.903C1623.5 309.745 1619.85 311.43 1616.48 308.341C1613.11 305.533 1610.3 297.669 1610.3 297.669C1610.3 297.669 1600.75 275.2 1596.82 264.528C1592.89 253.856 1589.52 242.06 1598.22 237.566C1606.93 233.354 1613.67 229.422 1638.1 219.873C1662.54 210.324 1697.36 203.022 1709.72 212.29C1722.08 221.558 1724.61 232.23 1724.61 232.23Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1701.58 274.358L1703.26 239.813",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1701.86 262C1701.86 262 1720.96 261.439 1722.92 237.004",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1604.68 283.625C1604.68 283.625 1598.5 265.37 1603.84 256.663C1609.18 247.957 1629.4 234.476 1629.4 234.476",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1739.77 570.094C1738.09 568.971 1708.04 537.234 1707.47 534.988C1706.91 532.741 1706.35 502.128 1702.98 495.388C1699.61 488.647 1688.38 468.707 1687.81 462.528C1687.25 456.349 1687.25 435.285 1687.81 427.983C1688.38 420.681 1681.07 420.119 1676.02 426.86C1670.96 433.6 1669.84 443.149 1669.84 451.575C1669.84 460 1669.28 466.741 1668.15 468.426C1667.03 470.111 1657.48 478.536 1652.99 479.66C1648.5 480.783 1621.25 467.302 1613.39 464.494C1605.52 461.685 1600.47 438.655 1599.35 436.128C1598.22 433.881 1597.66 417.03 1597.1 413.098C1596.54 409.166 1589.24 404.111 1586.43 413.66C1583.62 423.209 1584.74 445.958 1585.3 452.136C1585.87 458.315 1585.3 471.234 1588.11 474.604C1590.92 477.975 1608.9 493.702 1610.58 495.949C1612.27 498.196 1619.01 520.103 1621.25 523.754C1623.5 527.124 1642.6 534.426 1655.8 542.29C1668.72 550.154 1682.48 562.511 1682.48 562.511C1682.48 562.511 1678.55 567.005 1682.48 570.937C1686.41 574.869 1693.71 577.677 1693.71 577.677L1705.51 606.043L1739.77 570.094Z",
    fill: "#B5B5B5",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1621.25 524.317C1619.01 520.946 1612.27 499.04 1610.58 496.512C1608.9 494.265 1590.92 478.538 1588.11 475.167C1585.3 471.797 1585.87 458.878 1585.3 452.699C1584.74 446.521 1583.62 423.772 1586.43 414.223C1589.24 404.674 1596.54 409.729 1597.1 413.661C1597.66 417.593 1598.22 434.444 1599.35 436.691C1600.47 438.938 1605.53 461.967 1613.39 465.057C1621.25 467.865 1648.5 481.346 1652.99 480.223C1657.48 479.099 1667.03 470.674 1668.16 468.989C1669.28 467.304 1669.84 460.563 1669.84 452.138C1669.84 443.712 1670.96 434.163 1676.02 427.423C1681.07 420.682 1688.38 421.244 1687.82 428.546C1687.25 435.848 1687.25 456.912 1687.82 463.091C1688.38 469.27 1699.61 488.929 1702.98 495.951C1706.35 502.691 1706.91 533.304 1707.47 535.551C1707.76 536.674 1715.9 545.661 1724.04 554.368L1693.99 580.206L1693.43 579.083C1693.43 579.083 1686.13 576.274 1682.2 572.342C1678.27 568.41 1682.2 563.917 1682.2 563.917C1682.2 563.917 1668.72 551.559 1655.52 543.695C1642.6 535.27 1623.5 527.968 1621.25 524.317Z",
    fill: "#FDFDFD",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.58 496.792L1629.68 510.835",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1990.85 529.372C1990.85 529.372 1961.65 524.316 1944.51 538.078C1927.38 551.84 1921.2 577.678 1920.36 580.206C1919.52 582.734 1838.63 656.598 1838.63 656.598L1737.25 563.074L1687.53 611.942C1687.53 611.942 1751.01 692.828 1783.87 723.721C1816.73 754.615 1840.6 768.938 1846.78 771.747C1852.68 774.275 1858.85 771.747 1865.59 767.534C1872.33 763.321 2015.01 619.806 2015.01 619.806",
    fill: "#DFE33D"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1990.85 529.372C1990.85 529.372 1961.65 524.316 1944.51 538.078C1927.38 551.84 1921.2 577.678 1920.36 580.206C1919.52 582.734 1838.63 656.598 1838.63 656.598L1737.25 563.074L1687.53 611.942C1687.53 611.942 1751.01 692.828 1783.87 723.721C1816.73 754.615 1840.6 768.938 1846.78 771.747C1852.68 774.275 1858.85 771.747 1865.59 767.534C1872.33 763.321 2015.01 619.806 2015.01 619.806",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1992.82 589.474C1992.82 589.474 1966.14 564.478 1952.38 563.635C1938.62 562.793 1929.07 574.027 1929.07 574.027",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M2006.58 568.97C2006.58 568.97 1974 547.626 1954.9 557.736",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.91 656.598C1838.91 656.598 1861.38 703.781 1857.73 726.249",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1843.13 659.125C1843.13 659.125 1866.44 673.729 1874.86 701.253",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1629.4 426.297H1630.24C1633.61 426.297 1636.14 423.489 1636.14 420.399V382.765H1623.22V420.399C1623.5 423.77 1626.03 426.297 1629.4 426.297Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1620.41 374.902H1639.51V387.821H1620.41V374.902Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1605.24 426.297H1606.09C1609.46 426.297 1611.98 423.489 1611.98 420.399V382.765H1599.07V420.399C1599.07 423.77 1601.87 426.297 1605.24 426.297Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1595.98 374.902H1615.07V387.821H1595.98V374.902Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1590.64 402.426H1673.21V444.834H1590.64V402.426Z",
    fill: "#969696",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1419.86 451.009H1403.79V469.013H1419.86V451.009Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1426.05 444.04H1395.46V455.074H1426.05V444.04Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1445.41 463.398H1376.69V646.921H1445.41V463.398Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.4 535.802C1413.24 535.802 1421.21 527.828 1421.21 517.991C1421.21 508.155 1413.24 500.181 1403.4 500.181C1393.56 500.181 1385.59 508.155 1385.59 517.991C1385.59 527.828 1393.56 535.802 1403.4 535.802Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.82 693.576L1516.26 654.084H1425.28L1393.91 693.576H1547.82Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.04 654.473H1422.37C1416.37 654.473 1411.34 649.633 1411.34 643.438V642.664H1557.88V643.438C1558.08 649.633 1553.05 654.473 1547.04 654.473Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.89 401.083L1471.31 419.052L1474.91 424.566L1502.48 406.597L1498.89 401.083Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.56 381.998L1488.77 398.804L1499.55 415.347L1525.34 398.541L1514.56 381.998Z",
    fill: "#D7D7D7",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1414.05 357.118H1407.85V377.252H1414.05V357.118Z",
    fill: "#005D5F",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1416.95 375.896H1404.37V415.582H1416.95V375.896Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.28 411.324H1396.04V434.167H1425.28V411.324Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1472.51 400.289L1439.21 428.553L1365.46 434.942L1367.2 453.913L1456.06 446.17L1486.26 423.713L1472.51 400.289Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.57 709.678H1306.34C1301.82 709.678 1298.12 705.979 1298.12 701.459V618.045H1316V701.459C1315.79 705.979 1312.09 709.678 1307.57 709.678Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.92 651.739V700.637C1297.92 705.568 1301.82 709.472 1306.75 709.472C1311.68 709.472 1315.59 705.568 1315.59 700.637V651.534H1297.92V651.739Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.87 615.169H1294.84V632.016H1318.87V615.169Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.47 709.678C1336.54 709.678 1332.64 705.774 1332.64 700.843V618.045H1350.51V700.638C1350.51 705.569 1346.4 709.678 1341.47 709.678Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.64 651.739V700.637C1332.64 705.568 1336.54 709.472 1341.47 709.472C1346.4 709.472 1350.31 705.568 1350.31 700.637V651.534H1332.64V651.739Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.6 615.169H1329.56V632.016H1353.6V615.169Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.2 709.678C1371.27 709.678 1367.36 705.774 1367.36 700.843V618.045H1385.24V700.638C1385.24 705.569 1381.13 709.678 1376.2 709.678Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1367.36 651.739V700.637C1367.36 705.568 1371.27 709.472 1376.2 709.472C1381.13 709.472 1385.03 705.568 1385.03 700.637V651.534H1367.36V651.739Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1388.11 615.169H1364.07V632.016H1388.11V615.169Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1410.92 709.678C1405.99 709.678 1402.08 705.774 1402.08 700.843V618.045H1419.96V700.638C1419.96 705.569 1415.85 709.678 1410.92 709.678Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1402.08 651.739V700.637C1402.08 705.568 1405.99 709.472 1410.92 709.472C1415.85 709.472 1419.75 705.568 1419.75 700.637V651.534H1402.08V651.739Z",
    fill: "#DFE33D",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1422.83 615.169H1398.8V632.016H1422.83V615.169Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.04 641.056H1282.71V646.397H1438.04V701.459H1275.11V714.197H1448.72V711.116V701.459V646.397V641.056H1438.04Z",
    fill: "white",
    stroke: "#005D5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovativeAntibodies);
export default __webpack_public_path__ + "static/media/innovative-antibodies.3cecafa296f17997a476d01634b18c68.svg";
export { ForwardRef as ReactComponent };